export const CALENDAR_DAY_HEIGHT = 63
export const MONTH_COLUMN_WIDTH = 36
export const MIN_DAY_WIDTH = 36
export const CALENDAR_ROWS = 12
export const CALENDAR_COLUMNS = 37
export const WEEK_DAY_HEADER_HEIGHT = 30

export const getDayWidth = (containerWidth: number, columns: number) =>
  containerWidth > 0
    ? Math.max(
        MIN_DAY_WIDTH,
        Math.floor((containerWidth - MONTH_COLUMN_WIDTH) / columns),
      )
    : MIN_DAY_WIDTH
